// ============================================================
// summaries.nav.ts — Phase-4 migration descriptor
// ------------------------------------------------------------
// Component-free, data-only navigation descriptor for the Admin
// Summaries group (Installation / Product / My Product summary). Imports
// ONLY pure types/constants (@twist/ui-navigation types + @twist/core
// security primitives) — no component / feature code — so the registry
// stays a pure data graph.
//
// Mirrors the legacy sideNavConfig "Admin › Summaries" group: the
// group-parent + every sub-item are gated TWIST_ADMIN_ONLY
// (orgTypes: [TwistAdmin]) — identical to the legacy group constraint and
// now matched by the /summaries route guard.
//
// Whole-group migration: the children carry the `sidebar` surface so the
// legacy "Summaries" Admin group de-dups out (every sub-item path is
// piloted). The registry projects this descriptor as a SINGLE top-level
// "Summaries" leaf (→ /summaries/installation); the children power de-dup
// + the command palette + breadcrumb resolution.
// ============================================================
import { TWIST_ADMIN_ONLY } from '@twist/core';
import type { NavDescriptor } from '@twist/ui-navigation';

export const summariesNav: NavDescriptor = {
  id: 'summaries',
  path: '/summaries/installation',
  label: 'Summaries',
  icon: 'gearsDatabase',
  group: 'Admin',
  // Admin section = 40s; Summaries last (matches the recovered
  // sideNavConfig order).
  order: 43,
  surfaces: ['sidebar', 'palette'],
  security: TWIST_ADMIN_ONLY,
  children: [
    {
      id: 'summaries-installation',
      path: '/summaries/installation',
      label: 'Installation Summary',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
    {
      id: 'summaries-product',
      path: '/summaries/product',
      label: 'Product Summary',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
    {
      id: 'summaries-my-products',
      path: '/summaries/my-products',
      label: 'My Product Summary',
      group: 'Admin',
      surfaces: ['sidebar', 'palette'],
      security: TWIST_ADMIN_ONLY,
    },
  ],
};
